// Settings › Rotation › Priority tiers — what one agent row SAYS about its
// server stats. Pure, module-scope, no React: the gate
// (crm-aro-backend/verify-rotation-slice-stats.js) RUNS it rather than reading
// the row's JSX.
//
// WHY (2026-10-28). The row read tierAgentStats[uid].untouched — a LEAD-level
// count ("has anyone ever touched this client") — and labelled it "uncalled",
// so every tier agent showed 0 while the live feed was rotating leads to them.
// Owner decisions 2026-10-28: the row reads the agent's OWN slice — today as
// the main number, this week (Saturday→Friday, Cairo) muted beside it — and
// "uncalled" means received in the window with NO action by this agent since
// assignment (no Call tap, status change, feedback, note or callback).
// Previous holders' work never counts. "N active" is the leads this agent is
// the CURRENT (latest, top-level) holder of — owner ruling 2026-10-28, the
// pre-change number (Waad 376) — not every active slice, which on a rotated
// book counts leads long since rotated on to someone else (1,051 / 6,123).
//
// Every field is read only when it is a number; the deprecated `untouched`
// field is never read. A missing stat renders nothing — never a fake 0 — and
// the active count falls back to the old top-level count, then to the
// caller's bootstrap estimate.
export var UNCALLED_DEFINITION =
  "Uncalled = leads this agent received (their own slice, Cairo day) with no action by them since assignment: " +
  "no Call tap, status change, feedback, note or callback. Previous holders' work never counts.";
export var ACTIVE_HELD_TITLE = "leads this agent currently holds (latest holder)";

function num(v) { return typeof v === "number" && isFinite(v) ? v : null; }

export var tierRowStats = function (s, fallbackActive) {
  var held = s ? num(s.activeHeld) : null;
  var topLevel = s ? num(s.active) : null;          // the pre-2026-10-28 field, same meaning, older server
  var active = held != null ? held : (topLevel != null ? topLevel : (num(fallbackActive) != null ? num(fallbackActive) : 0));
  var rt = s ? num(s.receivedToday) : null, ut = s ? num(s.uncalledToday) : null;
  var rw = s ? num(s.receivedWeek) : null, uw = s ? num(s.uncalledWeek) : null;
  var haveToday = rt != null && ut != null, haveWeek = rw != null && uw != null;
  return {
    activeLabel: active + " active",
    activeTitle: ACTIVE_HELD_TITLE,
    todayLine: haveToday ? (rt + " received · " + ut + " uncalled today") : null,
    weekLine: haveWeek ? (rw + "/" + uw + " wk") : null,
    title: UNCALLED_DEFINITION + (haveWeek ? (" This week (Sat–Fri): " + rw + " received, " + uw + " uncalled.") : "")
  };
};
